import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        clientId: String,
        loginUrl: String
    }

    connect() {
    }

    async handleLogin(event) {
        if (!window.IdentityCredential) {
            return  // FedCM not supported, allow default link/form submission (Omniauth redirect)
        }

        event.preventDefault()
        event.stopImmediatePropagation() // Ensure other listeners don't fire if any

        try {
            const credential = await navigator.credentials.get({
                identity: {
                    providers: [
                        {
                            configURL: "https://accounts.google.com/gsi/fedcm.json",
                            clientId: this.clientIdValue,
                            nonce: this.generateNonce()
                        }
                    ],
                    mode: 'active',
                },
                mediation: 'optional',
            })

            if (credential && credential.token) {
                await this.submitCredential(credential.token)
            }
        } catch (error) {
            console.log("FedCM Login flow interrupted or failed:", error)

            // Fall back to the standard OmniAuth redirect on every failure except a
            // genuine user abort. Chrome reports most non-user failures (prompt
            // auto-dismissed, third-party sign-in disabled, in-app browsers, no
            // Google session) as NetworkError, so treating those as cancellations
            // left the button doing nothing.
            if (error.name === "AbortError") {
                return
            }

            const form = event.target?.closest("form")

            if (form) {
                form.submit()
            }
        }
    }

    async submitCredential(token) {
        try {
            const response = await fetch(this.loginUrlValue, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
                },
                body: JSON.stringify({ credential: token })
            })

            if (!response.ok) {
                throw new Error("Network response was not ok")
            }

            const data = await response.json()

            if (data.success) {
                if (window.Turbo) {
                    window.Turbo.visit(data.redirect_url)
                } else {
                    window.location.href = data.redirect_url
                }
            } else {
                console.error("Login failed:", data.error)
            }
        } catch (error) {
            console.error("Error submitting credential:", error)
        }
    }

    generateNonce() {
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);
        return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    }
}

